<template>
  <div class="newPer">
    <img src="../../assets/images/newper.png">
    <div style="background: #c4332f;padding-bottom: 0.09rem;">
      <div class="newPerTitle">
      <img src="../../assets/images/newpertitle.png">
      <ul>
        <li v-for="(item, index) of list" :key="index">
          <div class="product">
            <img :src="item.imgUrl">
            <div class="tags">
              <p>产品卖点</p>
              <p>产品卖点</p>
              <p>产品卖点</p>
            </div>
          </div>
          <p>{{item.title}}</p>
          <div class="span">
            <img src="../../assets/images/newprice.png">
            <div class="goods_price">
                  <span class="smallprice">
                    <sub>¥</sub>
                    <b>{{String(item.price.toFixed(2)).slice(0, String(item.price.toFixed(2)).indexOf('.'))}}</b>
                    <sup>{{String(item.price.toFixed(2)).slice(String(item.price.toFixed(2)).indexOf('.'), String(item.price.toFixed(2)).length)}}</sup>
                  </span>
            </div>
            <i>¥{{item.beforePrice.toFixed(2)}}</i>
          </div>
        </li>
      </ul>
    </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'newPerson',
  data () {
    return {
      list: [
        {
          imgUrl: require('../../assets/images/product.png'),
          title: '可丽金类人胶原蛋白健肤控油面膜保湿喷雾',
          price: 9349.00,
          beforePrice: 720.00
        },
        {
          imgUrl: require('../../assets/images/product.png'),
          title: '可丽金类人胶原蛋白健肤控油面膜保湿喷雾',
          price: 9349.00,
          beforePrice: 720.00
        },
        {
          imgUrl: require('../../assets/images/product.png'),
          title: '可丽金类人胶原蛋白健肤控油面膜保湿喷雾',
          price: 9349.00,
          beforePrice: 720.00
        },
        {
          imgUrl: require('../../assets/images/product.png'),
          title: '可丽金类人胶原蛋白健肤控油面膜保湿喷雾',
          price: 9349.00,
          beforePrice: 720.00
        }
      ]
    }
  },
  mounted: function () {
    window.scrollTo(0, 0)
  }
}
</script>

<style scoped lang="scss">
  /*.newPer .newPerTitle ul li span b {*/
    /*display: flex;*/
    /*display: -moz-flex;*/
    /*display: -ms-flex;*/
    /*display: -o-flex;*/
    /*display: -webkit-flex;*/
    /*justify-content: space-between;*/
    /*-moz-justify-content: space-between;*/
    /*-ms-justify-content: space-between;*/
    /*-o-justify-content: space-between;*/
    /*-webkit-justify-content: space-between;*/
  /*}*/
  .newPer {
    min-height: 100%;
    background: #C4332F;
    img {
      width: 100%;
    }
    .newPerTitle {
      margin: 0.02rem 0.11rem 0;
      border-radius:0.04rem;
      background: #fff;
      ul {
        margin: 0.09rem 0.11rem 0;
        display: flex;
        display: -moz-flex;
        display: -ms-flex;
        display: -o-flex;
        display: -webkit-flex;
        flex-wrap: wrap;
        -moz-flex-wrap: wrap;
        -ms-flex-wrap: wrap;
        -o-flex-wrap: wrap;
        -webkit-flex-wrap: wrap;
        li {
          width: 50%;
          &:nth-of-type(2n-1) {
            padding-right: 0.05rem;
          }
          &:nth-of-type(2n) {
            padding-left: 0.05rem;
          }
          .product {
            position: relative;
            >img {
              width: 100%;
            }
            .tags {
              position: absolute;
              bottom: 0;
              margin-bottom: 0.11rem;
              p {
                padding: 0.01rem  0.04rem;
                font-size: 0.11rem;
                color: #FFFFFF;
                height:0.18rem;
                border-radius:0px 1rem 1rem 0px;
                margin: 0;
                margin-bottom: 0.05rem;
                line-height:0.18rem;
                &:first-of-type {
                  background:linear-gradient(right,rgba(253,136,164,1) 0%,rgba(232,77,107,1) 100%);
                  background: -moz-linear-gradient(right,rgba(253,136,164,1) 0%,rgba(232,77,107,1) 100%);
                  background: -ms-linear-gradient(right,rgba(253,136,164,1) 0%,rgba(232,77,107,1) 100%);
                  background: -o-linear-gradient(right,rgba(253,136,164,1) 0%,rgba(232,77,107,1) 100%);
                  background: -webkit-linear-gradient(right,rgba(253,136,164,1) 0%,rgba(232,77,107,1) 100%);
                }
                &:nth-of-type(2) {
                  background:linear-gradient(270deg,rgba(193,141,241,1) 0%,rgba(141,84,223,1) 100%);
                  background: -moz-linear-gradient(270deg,rgba(193,141,241,1) 0%,rgba(141,84,223,1) 100%);
                  background: -ms-linear-gradient(270deg,rgba(193,141,241,1) 0%,rgba(141,84,223,1) 100%);
                  background: -o-linear-gradient(270deg,rgba(193,141,241,1) 0%,rgba(141,84,223,1) 100%);
                  background: -webkit-linear-gradient(270deg,rgba(193,141,241,1) 0%,rgba(141,84,223,1) 100%);
                }
                &:last-of-type{
                  margin-bottom: 0;
                  background:linear-gradient(90deg,rgba(239,0,32,1) 0%,rgba(255,20,79,1) 100%);
                  background: -moz-linear-gradient(90deg,rgba(239,0,32,1) 0%,rgba(255,20,79,1) 100%);
                  background: -ms-linear-gradient(90deg,rgba(239,0,32,1) 0%,rgba(255,20,79,1) 100%);
                  background: -o-linear-gradient(90deg,rgba(239,0,32,1) 0%,rgba(255,20,79,1) 100%);
                  background: -webkit-linear-gradient(90deg,rgba(239,0,32,1) 0%,rgba(255,20,79,1) 100%);
                }
              }
            }
          }
          p {
            font-size:0.13rem;
            font-weight:400;
            color:rgba(124,121,122,1);
            line-height:0.18rem;
            margin: 0.12rem 0 0.07rem;
            height: 0.36rem;
          }
          .span {
            display: flex;
            display: -moz-flex;
            display: -ms-flex;
            display: -o-flex;
            display: -webkit-flex;
            overflow: hidden;
            font-size: 0;
            img {
              width: 0.4rem;
              height: 0.2rem;
              margin-top: 0.06rem;
            }
            .goods_price{
              color:#FC0324;
              display: inline-block;
              font-size:0.22rem;
              font-weight:400;
              color:rgba(251,109,94,1);
              line-height:0.3rem;
              margin-left: 0.02rem;
              margin-right: 0.04rem;
              .smallprice {
                font-size: 0;
                b {
                  font-size:0.22rem;
                  line-height:0.3rem;
                  font-weight: 400;
                  letter-spacing: -0.01rem;
                }
              }
              sub {
                font-weight: normal;
                font-size: .13rem;
                vertical-align: baseline;
                /*letter-spacing: -0.01rem;*/
              }
              sup {
                font-size: 0.13rem;
                vertical-align: baseline;
                font-weight: normal;
                /*letter-spacing: -0.01rem;*/
              }
            }
            >i {
              line-height: 0.35rem;
              font-size:0.11rem;
              color:#6C6C6C;
              font-style: normal;
              text-decoration: line-through ;
              font-weight: 400;
              margin-left: 0.03rem;
              display: block;
              letter-spacing: -0.01rem;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/homepage/newPerson.vue